/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    import VariableType = Wars.Domain.Model.Codes.Enums.VariableType;

    export class SchemaProperty implements Wars.Domain.Model.SchemaProperty {
        id: string;
        
        parentObjectSchema: Wars.Domain.Model.ObjectSchema;
        objectSchema_id: string;
        name: string;
        required: boolean;
        propertyType: Wars.Domain.Model.Codes.Enums.VariableType;
        codeGroup: Wars.Domain.Model.Codes.CodeGroup;
        codeGroup_id?: string;
        type_id?: string;
        typeSchema: Wars.Domain.Model.ObjectSchema;
        uniqueIdentifier: string;
        isIndexed: boolean;
        systemVariable_id?: string;
        systemVariable: Wars.Domain.Model.SchemaProperty;
        scheduledResourceConfiguration_id?: string;
        scheduledResourceConfiguration: Wars.Domain.Model.ScheduledResourceConfiguration;
        paymentConfiguration_id?: string;
        paymentConfiguration: Wars.Domain.Model.Payment.PaymentConfiguration;
        canDownloadSecureDocumentSecurityMatrix_id?: string;
        canDownloadSecureDocumentSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        canSecureDocumentSecurityMatrix_id?: string;
        canSecureDocumentSecurityMatrix: Wars.Domain.Model.SecurityMatrix;
        documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        documentConfiguration_id: string;
        isSystemLevel: boolean;
        entityAspect: breeze.EntityAspect;
        entityType: breeze.EntityType;
        lastUpdateUserName: string;

        clonedFromId:string;
    }
}